<script setup>
import { onMounted, ref, computed } from "vue";
import axios from 'axios';
// const modalActive = ref(false);
// const toggleModal = () =>{
//     modalActive.value = !modalActive.value;
// };

// import ArgonButton from "@/components/ArgonButton.vue";
// let sewaProfileModal;
const customerList = ref([]);
let quicksearch = ref('');
onMounted(() => {
    getCustomerList();
    // sewaProfileModal = new Modal(document.getElementById('sewaProfileModal'));
});
let model = {
    customer: {
        customerid:'',
        name:'',
        ic:'',
        contact:'',
        address:'',
        company:'',
    },
};
const filteredCustomers = computed(() => {
      if (!quicksearch.value) return customerList.value
      return customerList.value.filter(item =>{
        let iName = item?.name ?? ""
        let iIc = item?.ic ?? ""
        let iCompany = item?.company ?? ""
        let iAddress = item?.address ?? ""
        let iWhatsapp = item?.whatsapp ?? ""
        let iContact = item?.contact ?? ""
        let q = quicksearch.value ?? ""
        return (
            iName.toLowerCase().includes(q.toLowerCase()) ||
            iCompany.toLowerCase().includes(q.toLowerCase())||
            iIc.toLowerCase().includes(q.toLowerCase())||
            iContact.toLowerCase().includes(q.toLowerCase())||
            iAddress.toLowerCase().includes(q.toLowerCase())||
            iWhatsapp.toLowerCase().includes(q.toLowerCase())
        )
      })
    });
function getCustomerList(){
    axios.get('order/listAllCustomer')
        .then(res => {
            customerList.value = res.data.customerList;
        }).catch(function (error){
            
            console.log('Error',error.message);
        });
};
function selectCustomer(customerid){
    const customer = customerList.value.find(c => c.customerid === customerid);
    if (customer) {
        // update your model
        model.customer.customerid = customer.customerid;
        model.customer.name = customer.name;
        model.customer.company = customer.company;
        model.customer.address = customer.address;
        model.customer.contact = customer.contact; 
        model.customer.ic = customer.ic; 
    } else {
        console.warn("Customer not found:", customerid);
    }
    emit('customerModel',model.customer);
};
const emit = defineEmits(['customerModel']);
</script>
<template>
  <!-- Modal -->
  <div class="modal fade" id="CustomerListModal" tabindex="-1" aria-labelledby="CustomerList" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="CustomerList">Customer List</h5>
          <button type="button" class="btn" data-bs-dismiss="modal" aria-label="Close">X</button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-md-6">
                <label for="example-text-input" class="form-control-label text-danger">Quick Search</label>
                <input class="form-control" id="input_search" type="text" placeholder="Contactn, Company, Name, address ..." v-model="quicksearch" />
            </div>
          </div>
          <hr />
          <div class="row">
            <div class="col-md-12">
                <table class="table align-items-center mb-0">
                    <thead>
                        <td class="text-uppercase text-secondary text-sm font-weight-bolder">Name</td>
                        <td class="text-uppercase text-secondary text-sm font-weight-bolder">Contact</td>
                        <td class="text-uppercase text-secondary text-sm font-weight-bolder">Address</td>
                        <td class="text-uppercase text-secondary text-sm font-weight-bolder"></td>
                        <td></td>
                    </thead>
                    <tbody>
                        <tr v-for="(item,index) in filteredCustomers" :key="index">
                            <td style="max-width: 30%; width: 30%; white-space: normal; word-wrap: break-word;">
                                <div class="d-flex px-2 py-1">
                                    <div class="d-flex flex-column justify-content-center">
                                        <h6 class="mb-0 text-sm">{{ item.name }}</h6>
                                        <h6 class="mb-0 text-sm">{{ item.company }}</h6>
                                    </div>
                                </div>
                            </td>
                            <td style="max-width: 30%; width: 30%; white-space: normal; word-wrap: break-word;">
                                <h6 class="text-xs font-weight-bold mb-0">{{ item.contact }}/ {{ item.whatsapp }}</h6>
                            </td>
                            <td style="max-width: 30%; width: 30%; white-space: normal; word-wrap: break-word;">
                                <h6 class="text-xs font-weight-bold mb-0">{{ item.address }}</h6>
                            </td>
                            <td>
                                <button class="btn btn-success" data-bs-dismiss="modal" @click="selectCustomer(item.customerid)">Select</button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>
</template>